const DB_NAME = 'nibyorDB';
const DB_VERSION = 1;

export const initDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('trends')) {
        db.createObjectStore('trends', { keyPath: 'id' });
      }
    };
  });
};

export const cacheTrends = async (trends) => {
  const db = await initDB();
  const tx = db.transaction('trends', 'readwrite');
  const store = tx.objectStore('trends');
  
  await Promise.all([
    store.put({ id: 'aiTrends', data: trends.aiTrends, timestamp: Date.now() }),
    store.put({ id: 'testingTrends', data: trends.testingTrends, timestamp: Date.now() }),
    store.put({ id: 'industryTrends', data: trends.industryTrends, timestamp: Date.now() })
  ]);
};

export const getCachedTrends = async () => {
  const db = await initDB();
  const tx = db.transaction('trends', 'readonly');
  const store = tx.objectStore('trends');
  
  const results = await Promise.all([
    store.get('aiTrends'),
    store.get('testingTrends'),
    store.get('industryTrends')
  ]);

  if (results.every(r => r && Date.now() - r.timestamp < 300000)) { // 5 min cache
    return {
      aiTrends: results[0].data,
      testingTrends: results[1].data,
      industryTrends: results[2].data
    };
  }
  return null;
};
